import { useEffect, useState } from "react";
import { FetchOrderStatus } from "../../redux/features/orderStatus/orderStatusAction";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { SharedTable } from "../../modules/common/table";
import SharedPagination from "../../modules/common/sharedPagination";
import "./style.css";
import { CommonTable } from "../../modules/common/table/Table";
import { orderListColumns } from "../../modules/common/table/columns/_orderListColumns";

const OrderStatusPage = () => {
  const dispatch: any = useDispatch();
  const [loading, setLoading] = useState(true);
  const headers = ["deviceId", "sku", "consumedQuantity", "updatedAt"];
  const [currentPage, setCurrentPage] = useState(1);
  const limit = 10;
  const states = useSelector((state: any) => state.orderStatusSlice);
  const orderList = states?.order || [];
  const totalRecord = states?.totalRecord || 0;
  const totalPages = Math.ceil(totalRecord / limit);


  useEffect(() => {
    const fetchOrders = async () => {
      try {
        await dispatch(FetchOrderStatus({ page: currentPage, limit }));
      } catch (error) {
        console.error("Failed to fetch orders:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, [currentPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <>
      <div className="order-status-container">
        <h2 className="page-title">Ordini</h2>

        <div className='orderListTable'>
          {loading ? (
            <p className="loading-text">Caricamento ordini...</p>
          ) : orderList?.length > 0 ? (
            <CommonTable data={orderList} columns={orderListColumns} />
          ) : (
            <p className="no-orders">Nessun ordine trovato.</p>
          )}
        </div>

        {totalRecord > 10 && <SharedPagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        />}

      </div>
    </>
  );
};

export default OrderStatusPage;
